<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="product-menu"
      :style="menuStyle"
      @mouseenter="$emit('mouseenter')"
      @mouseleave="$emit('mouseleave')"
    >
      <div class="product-menu__options">
        <button
          v-for="(option,index) in options"
          :key="option"
          :class="['product-menu__option', { 'product-menu__option--disabled': isOptionDisabled(option) }]"
          :disabled="isOptionDisabled(option)"
          @click="!isOptionDisabled(option) && $emit('select', option,index)"
        >
          {{ option }}
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
const MENU_OPTIONS = ['Battle card', 'Main slide', 'Sizing guide', 'Tender spec'];

export default {
  name: 'ProductMenu',
  props: {
    menuOptions: {
      type: Array,
      default: () => []
    },
    optionLinks: {
      type: Object,
      default: () => ({})
    },
    productName: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    position: {
      type: Object,
      default: () => ({ top: 0, left: 0, width: 0 })
    }
  },
  computed: {
    options() {
      return this.menuOptions && this.menuOptions.length ? this.menuOptions : MENU_OPTIONS;
    },
    menuStyle() {
      const w = Math.max(this.position.width || 0, 80);
      const style = {
        top: `${this.position.top}px`,
        left: `${this.position.left}px`,
        minWidth: `${w}px`,
        maxWidth: `${w}px`
      };
      if (this.position.transform) {
        style.transform = this.position.transform;
      }
      return style;
    }
  },
  methods: {
    isOptionDisabled(option) {
      if (!this.optionLinks || Object.keys(this.optionLinks).length === 0) return false;
      const link = this.optionLinks[option];
      return link === '' || link === null || link === undefined;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-menu {
  position: fixed;
  z-index: 1000;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  padding: 8px 0;

  &__options {
    display: flex;
    flex-direction: column;
    text-align: center;
  }

  &__option {
    padding: 10px 20px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
    color: #333 !important;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: #e6f2ff;
      color: #0f52ba !important;
    }

    &--disabled {
      opacity: 0.5;
      cursor: not-allowed;
      color: #999 !important;

      &:hover {
        background: transparent;
        color: #999 !important;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
